<a class="grid-link__renderer" [hidden]="!hasReceipt" (click)="onUserAction('viewRecipt')">{{text}}</a>